import React, { useEffect } from 'react';
import { useSelector} from 'react-redux';
import { createSelector } from 'reselect';
import { useTranslation } from 'react-i18next';

import { Tabs, TabList, TabPanel, Tab } from 'components/Tabs';
import { CardType, linkCards, integrationCards, callbackCards, educationCards, toolsCards } from 'constants/HomepageCards/Cards';
import { StandartCard, CallbackCard, IntegrationCard, ToolsCard, YoutubeVideoCard } from 'components/Cards';
import CardStatistic from 'components/Cards/CardStatistic';
import {useParams} from "react-router";

const memoizedSelector = createSelector(
  (state) => state.sellers.currentSeller,
  (currentSeller) => ({ currentSeller }),
);

function Home() {
  const { currentSeller } = useSelector(memoizedSelector);

  const { t } = useTranslation();
  const {tabName} = useParams();

  useEffect(() => {
    document.title = 'LK.MARKET';
  }, []);

  const renderNecessaryCard = (item) => {
    switch (item.type) {
      case CardType.link:
        {
          return <StandartCard key={item.title} sellerId={currentSeller.info.data?.id} Icon={item.icon} {...item} />;
        }
        break;

      case CardType.statistic:
        {
          return <CardStatistic Icon={item.icon} key={item.type} seller={currentSeller} />;
        }
        break;

      case CardType.callback:
        {
          return <CallbackCard Icon={item.icon} key={item.title} {...item} />;
        }
        break;

      case CardType.youtubeVideo:
        {
          return <YoutubeVideoCard Icon={item.icon} key={item.title} {...item} />;
        }
        break;

      case CardType.integration:
        {
          return <IntegrationCard Icon={item.icon} key={item.title} {...item} />
        }
        break;
      case CardType.tools:
      {
        return <ToolsCard Icon={item.icon} key={item.title} {...item} />
      }
        break;
    }
  };

  return (
    <Tabs
        tabPanelClassname="grid gap-4 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 max-h-screen overflow-auto"
        selected={tabName === 'tools' ? 4 : null}
    >
      <TabList>
        <Tab>{t("home")}</Tab>
        <Tab>{t("integration")}</Tab>
        <Tab>{t("Education")}</Tab>
        <Tab>{t("Partner Services")}</Tab>
        <Tab>{t("Tools")}</Tab>
      </TabList>
      <TabPanel>
        {
          linkCards && linkCards.map(renderNecessaryCard)
        }
      </TabPanel>
      <TabPanel>
        {
          integrationCards && integrationCards.map(renderNecessaryCard)
        }
      </TabPanel>
      <TabPanel>
        {
          educationCards && educationCards.map(renderNecessaryCard)
        }
      </TabPanel>
      <TabPanel>
        {
          callbackCards && callbackCards.map(renderNecessaryCard)
        }
      </TabPanel>
      <TabPanel>
        {
            toolsCards && toolsCards.map(renderNecessaryCard)
        }
      </TabPanel>
    </Tabs>
  );
}

export default React.memo(Home);
